<template>
  <div class="container mt-5">
    <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
    <section class="hero  is-light"  >
    <div class="hero-body">
        <p class="title">
        Primary hero
        </p>
        <p class="subtitle">
        Primary subtitle
        </p>
    </div>
    </section>



    <section class="container">
      <nav class="level is-mobile">
						<div class="level-left">
                            <div class="level-item">
                                  <b-dropdown aria-role="list">
                                    <template #trigger="{ active }">
                                        <b-button
                                            size="is-small"
                                            label=""
                                            type="is-ghost"
                                            :icon-right="active ? 'dots-vertical' : 'dots-horizontal'" />
                                    </template>


                                    <b-dropdown-item aria-role="listitem" @click="changeOPD" >Change OPD</b-dropdown-item>
                                    <b-dropdown-item aria-role="listitem" @click="init"  >Reload</b-dropdown-item> 
                                </b-dropdown>
                          
							</div>


							<div class="level-item">
                              <OPDInfo class="mt-5"  :dataToDisplay = "opdSelected"/>   	 
							</div>
						</div>
						<div class="level-right">
							<!-- <div class="level-item">
                                  <b-dropdown aria-role="list">
                                    <template #trigger="{ active }">
                                        <b-button
                                            size="is-small"
                                            label=""
                                            type="is-ghost"
                                            :icon-right="active ? 'dots-vertical' : 'dots-horizontal'" />
                                    </template>


                                    <b-dropdown-item aria-role="listitem"  >Change OPD</b-dropdown-item>
                                </b-dropdown>



                             <b-button 
                                type="is-primary is-light"
                                icon-left="swap-horizontal"
                                class="mb-3"
                                @click="searchOPD"
                                >Change OPD</b-button>	 
							</div> -->
						</div>
					</nav>
    </section>

    <!-- {{  :dataToEdit="dataToEdit['hm']"}} -->
    <!-- :mode="mode"  -->
    <section>
        <b-tabs v-model="activeTab">
            <b-tab-item label="Hematology" :icon="activeTab == 0 ? `checkbox-marked` : `` ">
                <HematologyParam   />
                <hr>
                <BlMor />
            </b-tab-item>

            <b-tab-item label="Blood Chemistry"   :icon="activeTab == 1 ? `checkbox-marked` : `` ">
                <BlChemParam  />
            </b-tab-item>

            <b-tab-item label="Body Fluid"   :icon="activeTab == 2 ? `checkbox-marked` : `` ">
                <BodyFluidParam  />
            </b-tab-item>


            <b-tab-item label="Blood Gas"   :icon="activeTab == 3 ? `checkbox-marked` : `` ">
                <BlGasParam  />
            </b-tab-item>

            <b-tab-item label="Hormone"   :icon="activeTab == 4 ? `checkbox-marked` : `` ">
                <HormoneParam  />
            </b-tab-item>


            <b-tab-item label="Blood Parasite"   :icon="activeTab == 5 ? `checkbox-marked` : `` ">
                <BlParasiteParam  />
            </b-tab-item>

            <b-tab-item label="Urine Analysis"   :icon="activeTab == 6 ? `checkbox-marked` : `` ">
                <UAParam />
            </b-tab-item>



        </b-tabs>

       
    </section>


   <SearchOPD  
          :mode="modeSearchOPD"
          @closeWithChangeForManualLabAutomate="closeSearchOPDWithChange"  
          ref="SearchOPD"/>


  </div>
  <!-- <div class="modal-card">
       <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
        <header class="modal-card-head "  >
       

                        <b-button type="is-text" 
                           size="is-large"
                           class="mb-3"
                           icon-left="arrow-left-bold-circle-outline" 
                          @click="close"></b-button>  


                        <OPDInfo class="mt-5"  :dataToDisplay = "opdSelected"/>   

                        <b-button 
                                type="is-primary is-light"
                                icon-left="swap-horizontal"
                                class="mb-3"
                                @click="searchOPD"
                                >Change OPD</b-button>	 
                                
                                  
                        <b-button 
                                type="is-info is-light"
                                icon-left="reload"
                                class="mb-3 ml-3"
                                @click="reloadBlankTemplate"
                                >Load New Template</b-button>	         
        </header>                   
         
        <section class="modal-card-body"> 
         
        

 


        <hr>

           <b-tabs v-model="activeTab"  @input="inputTabActive">
            <b-tab-item label="Hematology" :icon="activeTab == 0 ? `checkbox-marked` : `` ">
                <HematologyParam 
                :dataToEdit="dataToEdit['hm']"
                :mode="mode" />
                <hr>
                <BlMor />
            </b-tab-item>

            <b-tab-item label="Blood Chemistry"   :icon="activeTab == 1 ? `checkbox-marked` : `` ">
                <BlChemParam 
                :mode="mode" />
            </b-tab-item>

            <b-tab-item label="Hormone"  :icon="activeTab == 2 ? `checkbox-marked` : `` ">
                <HormoneParam 
                :mode="mode" />
            </b-tab-item>

            <b-tab-item label="Blood Gas"  :icon="activeTab == 3 ? `checkbox-marked` : `` ">
                  <BlGasParam 
                   :mode="mode" />
            </b-tab-item>


            <b-tab-item label="Blood Parasite"  :icon="activeTab == 4 ? `checkbox-marked` : `` ">
                <BlParasiteParam />
            </b-tab-item>


            <b-tab-item label="Urinalysis"  :icon="activeTab == 5 ? `checkbox-marked` : `` ">
                <UAParam 
                :mode="mode" />
            </b-tab-item>


            <b-tab-item label="Special Test"  :icon="activeTab == 6 ? `checkbox-marked` : `` ">
                What light is light, if Silvia be not seen? <br>
                What joy is joy, if Silvia be not by— <br>
                Unless it be to think that she is by <br>
                And feed upon the shadow of perfection? <br>
                Except I be by Silvia in the night, <br>
                There is no music in the nightingale.
            </b-tab-item>

            <b-tab-item label="Other"  :icon="activeTab == 7 ? `checkbox-marked` : `` ">
                What light is light, if Silvia be not seen? <br>
                What joy is joy, if Silvia be not by— <br>
                Unless it be to think that she is by <br>
                And feed upon the shadow of perfection? <br>
                Except I be by Silvia in the night, <br>
                There is no music in the nightingale.
            </b-tab-item>





         
        </b-tabs>
        </section> 
        <footer class="modal-card-foot"  >
            <b-button 
                                type="is-success is-light"
                                icon-left="upload"
                                @click="save"
                                >Save</b-button>	                       
        </footer>    

     <SearchOPD  
          :mode="modeSearchOPD"
          @closeWithChangeForManualLabAutomate="closeSearchOPDWithChange"  
          ref="SearchOPD"/>
    </div> -->
    
</template>



<script>

//  import { getBaseURLforBackEnd, customFormatDate,getConfigAxios }  from '@/utils.js'
//     import {mapState} from "vuex";
//     import { genUUID }  from '@/utils.js'
//     import axios from "axios";




 
import {mapActions, mapMutations, mapState} from "vuex";



import OPDInfo from '../../UtilsComponents/OPDInfo.vue'
import HematologyParam from './HematologyParam.vue'
import BlMor from './BlMor.vue'
import BlChemParam from './BlChemParam.vue'
import BodyFluidParam from './BodyFluidParam.vue'
import BlGasParam from './BlGasParam.vue' 
import HormoneParam from './HormoneParam.vue'
import BlParasiteParam from './BlParasiteParam.vue'
import UAParam from './UAParam.vue'
import SearchOPD from '../../SearchOPD.vue'


import {BLANK_OPD_FOR_MANUAL_LAB_AUTOMATE} from '@/utils.js'

 


export default {
    name : "ManuallyCreateLabAutomate",
    props:{
        isComponentModalActive : Boolean,
        mode : Number,  // 0--> new , 1 --> edit
        // dataToEdit : Object, 
    },
    
    components:{
          OPDInfo, 

          HematologyParam,
          BlMor,
          BlChemParam,
          BodyFluidParam,
          BlGasParam ,
          HormoneParam,


          BlParasiteParam ,
          UAParam,
     
          SearchOPD,
    },
    computed:{
            ...mapState({
                access_token : state => state.master_data.access_token,
                opdSelected : state => state.manually_create_lab_automate.opdSelected ,
                // labParam: state => state.manually_create_lab_automate.labParam ,
                lab_HIS_LIS_Mapping: state => state.manually_create_lab_automate.lab_HIS_LIS_Mapping ,
              
              
                dataModelMNLABAutomate : state => state.manually_create_lab_automate.dataModelMNLABAutomate ,
                blParasiteParam: state => state.manually_create_lab_automate.blParasiteParam , 



                modeManuallyLabAutomate: state => state.manually_create_lab_automate.modeManuallyLabAutomate ,  // 0 == new insert , 1 == edit mode
            }),
         


    },
    mounted(){
        // console.log("mount ManuallyCreateLabAutomate ")
         this.init()
          
        // 
         
    },
    methods:{
        // checkTabActive(){
        //     if this.activeTab
        //     return `checkbox-marked`
        // },
        //   setupIDLABTarget : 'lab_target/setupIDLABTarget',
        ...mapActions({
            // fetchNewModelManulaLABAutomate : 'manually_create_lab_automate/fetchNewModelManulaLABAutomate' ,
            fetchLab_his_lis_mapping: 'manually_create_lab_automate/fetchLab_his_lis_mapping' ,
            fetchBlMor: 'manually_create_lab_automate/fetchBlMor' ,
            fetchBlParasite: 'manually_create_lab_automate/fetchBlParasite' ,
            // fetchUAExtend: 'manually_create_lab_automate/fetchUAExtend' ,
            fetchUAParams: 'manually_create_lab_automate/fetchUAParams' ,
        }),

        ...mapMutations({
            setOpdSelected : 'manually_create_lab_automate/setOpdSelected' ,
            setDataModelMNLABAutomate: 'manually_create_lab_automate/setDataModelMNLABAutomate' ,
        }),
        // closeWithChangeForManualLabAutomate(payload){
        //        console.log(payload)
        //     //    this.$refs.SearchOPD.isComponentModalActive = false
        // }, 
        changeOPD(){
              this.modeSearchOPD =  1
              this.$refs.SearchOPD.isComponentModalActive = true
        },
        init(){
            this.activeTab = 0
            if(this.modeManuallyLabAutomate==0){
            //  console.log("1")
               this.reloadBlankTemplate() 
         
            }
        },
         
        close(){
            this.$emit('close')
        }, 
        closeSearchOPDWithChange(payload){
            // console.log(payload)
            this.setOpdSelected(
                   {
                    "address": payload.address  ,
                    "age": payload.age ,
                    "birth": payload.birth ,
                    "breed": payload.breed ,
                    "date_rec": payload.date_rec ,
                    "idopd": payload.idopd ,
                    "idown": payload.idown ,
                    "name": payload.name ,
                    "owner_name": payload.owner_name ,
                    "phone_mobile": payload.phone_mobile ,
                    "sex": payload.sex ,
                    "species": payload.species ,
                    "species_id": payload.species_id ,
                    "visit_active":payload.visit_active  ,
                 } 
            )



            // 
            this.$buefy.toast.open({
                    duration: 2500,
                    message: ` Change OPD to  <b>${payload.idopd}</b>  <i>${payload.name}</i>`,
                    position: 'is-bottom',
                    type: 'is-info'
            })




        },
        searchOPD(){
              this.$refs.SearchOPD.isComponentModalActive = true
        },
        inputTabActive(){
        //    console.log(this.activeTab)
        },
        reloadBlankTemplate(){
          
           // this.setDataModelMNLABAutomate( this.lab_HIS_LIS_Mapping.map( obj => ({ ...obj, "value": null })  ))   
           if(this.modeManuallyLabAutomate==0){
            this.setOpdSelected( BLANK_OPD_FOR_MANUAL_LAB_AUTOMATE )
           }
           



              this.fetchLab_his_lis_mapping()
                .then(()=>{
                    this.$buefy.snackbar.open({
                     message: `template has loaded `,
                     type: 'is-warning',
                     position: 'is-bottom-right',
                     duration : 500,
                     })
                } )

              this.fetchBlMor()
                .then(()=>{ 
                     this.$buefy.snackbar.open({
                     message: `Blood Mor has loaded `,
                     type: 'is-warning',
                     position: 'is-bottom-right',
                     duration : 500,
                     })})
           
              this.fetchBlParasite()
                 .then(()=> {
                    this.$buefy.snackbar.open({
                     message: `Blood Parasite has loaded `,
                     type: 'is-warning',
                     position: 'is-bottom-right',
                     duration : 500,
                     })
                    })

             this.fetchUAParams()
                 .then(()=> {
                    this.$buefy.snackbar.open({
                     message: `UA has loaded `,
                     type: 'is-warning',
                     position: 'is-bottom-right',
                     duration : 500,
                     })
                     })

    
        
         
         
        },
        save(){
            console.log( this.blParasiteParam )
        }
    },
    data(){
        return{
          isFullScreenLoading : false,

          activeTab : 0,
     
        //   modeParam : 0, // 0 ----> input mode  , 1 -----> edit mode
        //                  // in this component use to input value data and then set into 0
            

          modeSearchOPD : 1,

         //   dataModel : {}

        }
    },
    // watch:{
    //     isComponentModalActive:{
    //         immediate : true,
    //         handler: function(val){
    //             if(val){

    //             }
    //         }
    //     }
    // }
}
</script>


<style scoped>
 
</style>